import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Page } from "./types";
import ScrollToTop from "./ScrollToTop";
import PageHome from "containers/PageHome/PageHome";
import Page404 from "containers/Page404/Page404";
import PageLogin from "containers/PageLogin/PageLogin";
import SiteHeader from "containers/SiteHeader";
import { Toaster } from "react-hot-toast";
import { ProtectedRoute } from "./ProtectedRoute";
import UserEdit from "containers/UserPage/UserEdit";
import ShiftEdit from "containers/ShiftPage/ShiftEdit";
import ShiftPage from "containers/ShiftPage/ShiftPage";
import { useAuth } from "provider/useAuth";
import EmployeePlanning from "containers/PageHome/PlanningEmployee";
import UserPage from "containers/UserPage/UserPage";
import Invoice from "containers/InvoicePage/Invoice";
import Bulletins from "containers/PageHome/Bulletins";

export const pages: Page[] = [
	{ path: '/login', component: PageLogin, isAuthProtected: false },
	{
		path: '/',
		component: PageHome,
		isAuthProtected: true,
		isIndex: true,
		isAdmin: true,
	},
	{
		path: '/',
		component: EmployeePlanning,
		isAuthProtected: true,
		isIndex: true,
	},
	{
		path: '/',
		component: EmployeePlanning,
		isAuthProtected: true,
		isIndex: true,
	},
	{
		path: '/employes',
		component: UserPage,
		isAuthProtected: true,
		isAdmin: true,
	},
	{
		path: '/employe/:userId?',
		component: UserEdit,
		isAuthProtected: true,
		isAdmin: true,
	},
	{
		path: '/shifts',
		component: ShiftPage,
		isAuthProtected: true,
		isAdmin: true,
	},
	{
		path: '/shift/:shiftId?',
		component: ShiftEdit,
		isAuthProtected: true,
		isAdmin: true,
	},
	{
		path: '/planning',
		component: PageHome,
		isAuthProtected: true,
		isAdmin: true,
		isAccessConsultation: true,
		isManagerRoute: true,
	},
	{
		path: '/planning',
		component: EmployeePlanning,
		isAuthProtected: true,
		isAdmin: false,
	},
	{
		path: '/invoice',
		component: Invoice,
		isAuthProtected: true,
		isAdmin: true,
		isAccessConsultation: true,
	},
	{
		path: '/documents',
		component: Bulletins,
		isAuthProtected: true,
		isAdmin: false,
		isAccessConsultation: true,
	},
	{
		path: '/',
		component: Invoice,
		isAuthProtected: true,
		isAdmin: true,
		isAccessConsultation: true,
	},
	{ path: '/404', component: Page404, isAuthProtected: false },
];

const MyRoutes = () => {
	const { user, token } = useAuth();

	if (!token) {
		return (
			<>
				<Toaster />
				<Routes>
					<Route path="/login" element={<PageLogin />} />
					<Route path="*" element={<Navigate to="/login" replace />} />
				</Routes>
			</>
		);
	}

	return (
		<>
			<Toaster />
			<ScrollToTop />
			<SiteHeader />
			<Routes>
				{pages
					.filter((p) => {
						if (user && user.role === 'CONSULTATION')
							return p.isAccessConsultation;
						if (user && user.role === 'MANAGER')
							return !p.isAdmin || p.isManagerRoute;
						return !p.isAdmin || (user && user.role === 'ADMIN');
					})
					.map(
						(
							{
								component: Component,
								path,
								isAuthProtected,
								isIndex,
								isAdmin,
								isManagerRoute,
							},
							index,
						) => {
							return (
								<Route
									key={index}
									element={
										isAuthProtected ? (
											<ProtectedRoute
												isAdmin={isAdmin}
												isManagerRoute={isManagerRoute}
											>
												{' '}
												<Component />{' '}
											</ProtectedRoute>
										) : (
											<Component />
										)
									}
									path={path}
									index={isIndex ? true : false}
								/>
							);
						},
					)}
				<Route element={<Page404 />} />
			</Routes>
			{/* <Footer /> */}
		</>
	);
};

export default MyRoutes;
